module.exports = require("./doi.js");